import { RISK_STATUS } from '../shared/reputation-risk-status';

const getRiskStatus = ({isBlacklisted, riskScore}) => {
    if (isBlacklisted) {
        return RISK_STATUS.HIGH;
    }

    if (riskScore > 20) {
        return RISK_STATUS.MEDIUM;
    }

    return RISK_STATUS.LOW;
};

const domainReputationMapper = {
    toDomain(data) {
        return {
            type: 'domain',
            riskScore: data.riskScore,
            riskStatus: getRiskStatus(data),
            popularity: data.popularity,
            isBlacklisted: data.isBlacklisted,
            isMostAbusedTld: data.isMostAbusedTld,
            isRiskyCategory: data.isRiskyCategory,
            isFreeHosting: data.isFreeHosting
        }
    }
};

export {
    domainReputationMapper
};
